import { inject } from '@angular/core';
import { type ResolveFn } from '@angular/router';
import { Store } from '@ngxs/store';
import { of } from 'rxjs';
import { GetCountries, GetTimeZones } from '../states/location.actions';
import { LocationState } from '../states/location.state';

export const locationDataResolver: ResolveFn<void> = () => {
    const store = inject(Store);

    const countries = store.selectSnapshot(LocationState.countries);
    const timeZones = store.selectSnapshot(LocationState.timeZones);

    if (countries && timeZones) {
        return of(undefined);
    }

    return store.dispatch([new GetCountries(), new GetTimeZones()]);
};
